import { render, staticRenderFns } from "./WidgetBalance.vue?vue&type=template&id=139e6540&"
import script from "./WidgetBalance.vue?vue&type=script&lang=js&"
export * from "./WidgetBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports